import { atom } from 'jotai';

/**
 * 현재 페이지의 핵심 콘텐츠가 렌더링 완료되었는지 여부.
 * SplashScreen이 이 값이 true가 된 후 페이드아웃됨.
 * Layout 마운트 시점에 true로 설정되며, 특정 페이지에서 더 늦게 설정할 수도 있음.
 */
export const pageReadyAtom = atom(false);
